import axios from "axios";

const AdminAPI = axios.create({
  baseURL: "https://surajai.synovats.com/api/admin"
});

AdminAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default AdminAPI;